import { request } from "@/request/http";

export default {
  getOpenListByDate: (data) => {
    return request("POST", `/index.php/center/getOpenListByDate`, data);
  },

}
